import { isAPP } from "@/utils/util";
import APPRecorder from './app-recorder.vue'
import WebRecorder from './web-recorder.vue'

let LRecorder = isAPP ? APPRecorder : WebRecorder

export default LRecorder;